import { Component, HostListener, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ConfigurationModel } from 'src/app/models/configuration';
import { Project, ProjectUploadModel } from 'src/app/models/project';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { ProjectService } from 'src/app/services/project.service';
import {GritUserRoleGroup, GritUserService} from "../../services/grit/grit.user.service";

@Component({
  selector: 'app-create-project',
  templateUrl: './create-project.component.html',
  styleUrls: ['../../app.component.scss'],
  standalone: false
})
export class CreateProjectComponent {

  projectForm : FormGroup;
  @Input() nameExist : boolean = false;
  @Input() editMode : boolean;
  @Input() project : Project | ProjectUploadModel;

  constructor(
    protected gritUserService : GritUserService,
    public projectService : ProjectService,
    public bsModalRef : BsModalRef,
    private modalService: ModalControlService) {

    this.project = new Project();
    this.projectForm = new FormGroup({
        name: new FormControl('', [Validators.required]),
        description : new FormControl('',[Validators.required]),
        configuration: this.projectService.importMode? new FormControl('', []) : new FormControl('', [Validators.required]),
        originator: new FormControl('', [Validators.required]),
    });
    }

  @HostListener('document:keydown.escape', ['$event'])
  onEscape(event: KeyboardEvent) {
    this.cancel(false); // escape key already hides the modal
  }

  cancel(hideModal: boolean = true):void{
    this.projectService.importMode = false;
    hideModal? this.bsModalRef.hide(): false;
  }

  validateProjectName(event){
    this.nameExist = this.projectService.projects.findIndex(proj => proj.name == event.target.value) != -1 && !this.editMode;
  }

  saveProject():void {
    if (this.projectService.importMode){
      this.projectService.importProject(this.project as ProjectUploadModel);
    } else {
      this.projectService.saveProject(this.project, this.projectForm.get("originator").value);
    }

    this.nameExist = false;
    this.bsModalRef.hide();
  }

  protected readonly GritUserRoleGroup = GritUserRoleGroup;
}
